"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.debugLogWithExtUuid = exports.debugLog = exports.logTime = exports.trimObject = exports.trimArray = void 0;
var strftime_1 = __importDefault(require("strftime"));
var trimArray = function (arr) {
    return arr.map(function (a) {
        switch (typeof a) {
            case 'undefined':
                return '[UNDEFINED]';
            case 'function':
                return '[FUNC]';
            case 'object':
                if (a instanceof Array) {
                    return exports.trimArray(a);
                }
                else {
                    if (a === null) {
                        return '[NULL]';
                    }
                    else if (a === window) {
                        return '[WINDOW]';
                    }
                    else if (a === document) {
                        return '[DOCUMENT]';
                    }
                    else {
                        return exports.trimObject(a);
                    }
                }
            case 'boolean':
            case 'number':
            case 'string':
                return a;
            default:
                return '[INVALID]';
        }
    });
};
exports.trimArray = trimArray;
var trimObject = function (obj) {
    return Object.keys(obj).reduce(function (p, c) {
        if (['sCookie', 'kproto', 'vproto', 'proto'].indexOf(c) >= 0) {
            p[c] = '[' + c + ']';
        }
        else {
            switch (typeof obj[c]) {
                case 'undefined':
                    p[c] = '[UNDEFINED]';
                    break;
                case 'function':
                    p[c] = '[FUNC]';
                    break;
                case 'object':
                    if (obj[c] instanceof Array) {
                        p[c] = exports.trimArray(obj[c]);
                    }
                    else {
                        if (obj[c] === null) {
                            p[c] = '[NULL]';
                        }
                        else if (obj[c] === window) {
                            p[c] = '[WINDOW]';
                        }
                        else if (obj[c] === document) {
                            p[c] = '[DOCUMENT]';
                        }
                        else {
                            p[c] = exports.trimObject(obj[c]);
                        }
                    }
                    break;
                case 'boolean':
                case 'number':
                case 'string':
                    p[c] = obj[c];
                    break;
                default:
                    p[c] = '[INVALID]';
                    break;
            }
        }
        return p;
    }, {});
};
exports.trimObject = trimObject;
var logTime = function () {
    return strftime_1["default"]('%F %T.%L');
};
exports.logTime = logTime;
var debugLog = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (localStorage.getItem('HYEXT_WEB_MID_DEBUG_LOG') === '1') {
        console.log.apply(console, args);
    }
};
exports.debugLog = debugLog;
var debugLogWithExtUuid = function (extUuid) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (localStorage.getItem('HYEXT_WEB_MID_DEBUG_LOG_EXTUUID') === extUuid) {
        exports.debugLog.apply(null, __spreadArrays(["\u3010" + extUuid + "\u3011"], args));
    }
};
exports.debugLogWithExtUuid = debugLogWithExtUuid;
